import { render, staticRenderFns } from "./GarantiaView.vue?vue&type=template&id=63adff30&scoped=true"
import script from "./GarantiaView.vue?vue&type=script&lang=js"
export * from "./GarantiaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63adff30",
  null
  
)

export default component.exports